/**
 * Adzuki. My Settings - Credit Cards list actions
 *
 * SET-67, decision B3: the two mutating actions on the Credit Cards list are POSTs.
 *
 * THEY WERE GET LINKS, the same exposure the Shipping list had - and this pair is sharper, since
 * "make primary" decides which card the franchise's recurring charges are billed to and "delete"
 * removes an Authorize.Net payment profile along with the row.
 *
 * SET-133 MOVED THE MACHINERY OUT, and this file's old header was the reason. It said the two
 * panels were deliberately siblings rather than a shared helper, and named the condition that
 * would change that answer: a third list. SET-69's Franchise Documents was the third, and the
 * ajax, the three answers a list endpoint can give and the delegated binding now live in
 * my_settings_list_actions.js.
 *
 * NOTHING HERE WRITES ADVISOR-FACING COPY apart from the two last-resort failure strings below.
 * Success and refusal text comes from the response, and the delete confirmation is raised BY THE
 * SERVER - creditCardDelete() answers an unconfirmed request with a confirmation_prompt rather
 * than deleting. The recently-used refusal arrives the same way, as an ordinary error carrying
 * its own list of what blocked the delete, because only the database knows it.
 */

(function MySettingsFinancial($, Adzuki)
{
	"use strict";

	// INSIDE ready, NOT AT LOAD - see the note in my_settings_shipping.js. gulp concatenates this
	// directory alphabetically, so the helper has not been assigned yet at this point in the
	// bundle; it has by the time a ready callback runs.
	$(document).ready(function documentReady() {
		if (!Adzuki.MySettings || !Adzuki.MySettings.ListActions) {
			return;
		}

		Adzuki.MySettings.ListActions.bind({
			url    : '/MySettings/creditCards',
			actions: [
				{
					event   : 'change',
					selector: '.my-settings-card-primary',
					url     : function primary($control) {
						return '/MySettings/creditCardPrimary/' + $control.val();
					},
					failure: 'There was an error attempting to set the primary credit card.'
				},
				{
					event   : 'click',
					selector: '[data-my-settings-card-delete]',
					url     : function remove($control) {
						return '/MySettings/creditCardDelete/' + $control.attr('data-my-settings-card-delete');
					},
					failure: 'There was an error attempting to delete the credit card.'
				}
			]
		});
	});
}(jQuery, window.Adzuki || {}));
